import { graphql } from '@api/generated';

export const GET_ABANDONED_CALL_FOLLOW_UPS_COUNT_QUERY = graphql(`
  query abandonedCallsCount(
    $filter: AbandonedCallFollowUpFilterInput
    $take: Int
  ) {
    abandonedCallFollowUps(filter: $filter, take: $take) {
      totalCount
    }
  }
`);
